import React, { Component } from "react";
import {
  SelectField,
  MenuItem,
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  Menu,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import importDefaultIcon from "../../images/import_default.png";
import AddNewDocumentType from "./AddNewDocumentType";
import CreateMailingListIcon from "../../images/create_mailing_list.png";
import backIcon from "../../images/back.png";
import checkedIcon from "../../images/checked.png";
import addArrowIcon from "../../images/add_arrow.png";
import { sendgridTemplateList } from "../helpers.js";
import searchIcon from "../../images/search.png";

export default class ShowPayrollCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "Click to upload file, or drag and drop file",
      open: false,
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      value: "",
      file: "",
      response: "",
      isLoading: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "300px",
          border: "3px dashed #ebeff2",
        },
        activeZone: {
          width: "100%",
          height: "300px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      searchTextValue: "",
    };
    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
  }

  submitForm(data) {
    // alert(JSON.stringify(data, null, 4));
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url = "/api/payroll/upload";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          this.setState({ response: json, isLoading: false });
        });
    }
  }

  resetForm() {
    this.setState({ file: "", response: "", isLoading: false });
  }

  onDrop(e) {
    if (e[0].type === "application/pdf") {
      this.setState({ file: e[0] });
    } else {
      this.setState({ message: `Incorrect File Type, expecting PDF` });
    }
  }

  notifyFormError(data, msg) {
    alert(msg);
  }

  showCompanyDetail = (row, navValue) => {
    this.props.navigation(row, navValue);
  };

  deleteCompany = (row) => {
    this.setState({ openDeleteConfirmPopup: true, currentSelectedRow: row });
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  deleteCompanyData = () => {
    let { currentSelectedRow } = this.state;
    this.props.deleteCompany(currentSelectedRow);
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      this.props.navigation({}, "SHOW_PAYROLL_CHECK", searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    } else {
      this.setState({ searchTextValue: "" });
      this.props.navigation({}, "SHOW_PAYROLL_CHECK", "");
    }
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.showCompanyDetail(row, "SHOW_COMPANY_DETAIL");
        }}
        style={{ width: "25px", height: "25px" }}
      >
        <img src={editDefaultIcon} />
      </IconButton>
    );
  }

  deleteButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.deleteCompany(row);
        }}
        style={{ width: "25px", height: "25px" }}
      >
        <img src={deleteDefaultIcon} />
      </IconButton>
    );
  }

  renderTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"red"} />
          </center>
        </div>
      );
    } else {
      let { companies } = this.props;
      return (
        <div
          className="mainTableCls"
          style={{ overflowY: "inherit", width: "95%", margin: "0 auto" }}
        >
          <div>
            <div className="searchTextCls" style={{ display: "inline-block" }}>
              <input
                type="text"
                value={this.state.searchTextValue}
                className="searchInputCls"
                placeholder="Search"
                onChange={(e) => this.submitSearchForm(e.target.value)}
              />
              <span
                className="searchImgCls"
                onClick={() => {
                  this.clearSearchText();
                }}
              >
                <img src={searchIcon} style={{ width: "16px" }} />
              </span>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Link
                onClick={() =>
                  this.showCompanyDetail({}, "SHOW_COMPANY_DETAIL")
                }
                style={{ cursor: "pointer" }}
              >
                <img
                  src={CreateMailingListIcon}
                  style={{ width: "16px", marginRight: "5px" }}
                />
                Create Company
              </Link>
            </div>
          </div>
          <BootstrapTable data={companies} bordered={false} pagination>
            <TableHeaderColumn isKey={true} dataField="companyId" width="50">
              Client Id
            </TableHeaderColumn>
            <TableHeaderColumn dataField="company" width="150">
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.editButtonFormatter}
              width="20"
            ></TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.deleteButtonFormatter}
              width="20"
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"red"} />
            <h3>{this.state.message}</h3>
          </center>
        </div>
      );
    } else if (!response) {
      return (
        <div style={{ padding: "2rem" }}>
          <Dropzone
            className="rightUploadDiv"
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <center>
              <h4>
                {this.state.file ? this.state.file.name : this.state.message}
              </h4>
            </center>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div>
          <h4>In case of a failed email:</h4>
          <p>
            1.Download the individual paystub from AccountantsWorld for each
            failed email
          </p>
          <p>2. Reset form</p>
          <p>3. Upload single file</p>
          <p>4. Repeat step 2 and 3 for each paystub</p>
          <BootstrapTable data={response}>
            <TableHeaderColumn
              dataField="empId"
              filter={filter}
              dataSort
              isKey
              width="50"
            >
              EmpID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              width="300"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="checkDate"
              dataSort
              filter={filter}
              width="100"
            >
              Check Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="sent"
              dataSort
              filter={filter}
              width="100"
              dataFormat={this.sentFormatter}
            >
              Email Sent
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  handleChange = (value) => {
    console.log("value---------", value);
    this.setState({ value: value });
  };

  render() {
    let { openDeleteConfirmPopup } = this.state;
    let { open } = this.props;
    let { inputHr } = this.state.styles;
    return (
      <div style={{ display: open ? "block" : "none" }}>
        <div className="row" style={{ height: "calc(100vh)" }}>
          <div
            className="column d-flex align-items-stretch"
            style={{ backgroundColor: "#fff" }}
          >
            <div>
              <div
                style={{
                  backgroundColor: "#fff",
                  paddingLeft: "2rem",
                  borderRadius: "5px",
                }}
              >
                <SelectField
                  floatingLabelText="Select Email Template"
                  value={this.state.value}
                  style={{ backgroundColor: "#fff", width: "60%" }}
                >
                  {sendgridTemplateList && sendgridTemplateList.length
                    ? sendgridTemplateList.map(
                        (sendgridTemplateListData, index) => {
                          return (
                            <MenuItem
                              key={"welcome_" + index}
                              onClick={() => {
                                this.handleChange(sendgridTemplateListData.id);
                              }}
                              value={sendgridTemplateListData.id}
                              primaryText={sendgridTemplateListData.name}
                            />
                          );
                        },
                      )
                    : ""}
                </SelectField>
              </div>
              <br />
              <label style={{ paddingLeft: "1.5rem" }}> Company List</label>
              {this.renderTable()}
            </div>
          </div>
          <div className="column d-flex align-items-stretch rightMainDiv">
            <div>
              <Formsy.Form
                ref="form"
                onValidSubmit={this.submitNoteForm}
                onInvalidSubmit={this.notifyFormError}
              >
                <FormsyText
                  multiLine
                  name="note"
                  readOnly={true}
                  value="Payroll Check"
                  placeholder="Note..."
                  InputProps={{ disableUnderline: true }}
                  style={{
                    width: "93%",
                    marginLeft: "2rem",
                    marginBottom: "0",
                    height: "70px",
                    border: "1px solid #ccc",
                    padding: "10px",
                    marginTop: "0px",
                    maxHeight: "90px",
                  }}
                />
              </Formsy.Form>
            </div>
            {this.renderContent()}

            <div
              style={{
                float: "right",
                marginTop: "1rem",
                position: "absolute",
                right: "30px",
              }}
            >
              <FlatButton
                disabled={this.state.isLoading}
                onClick={this.resetForm.bind(this)}
                className="flatButtonCls"
              >
                Reset
              </FlatButton>
              <FlatButton
                disabled={this.state.isLoading || !!this.state.response}
                onClick={this.submitForm}
                style={{ marginLeft: "2rem" }}
                className="flatButtonCls"
              >
                Submit
              </FlatButton>
            </div>
          </div>
        </div>

        <Dialog
          title="Delete Company"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this company?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteCompanyData}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowPayrollCheck.js